'use strict';

var OnlineLogitCalibrationActionsDirective = function OnlineLogitCalibrationActionsDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/online-logit-calibration-actions.html'),
    scope: {
      classGroups: '=',
      dows: '=',
      filter: '='
    }
  };
};
OnlineLogitCalibrationActionsDirective.$inject = [];
module.exports = OnlineLogitCalibrationActionsDirective;